import React from 'react'

import { useIntl } from 'react-intl'
import { TableColumn } from 'react-data-table-component'

import DataTable from '../DataTable/DataTable'
import ShareLoanEmptyState from './ShareLoanEmptyState'
import type { UserRole } from '../modals/ModalShareLoan'
import ShareLoanActionsCell from './ShareLoanActionsCell'
import ShareLoanListNameCell from './ShareLoanListNameCell'
import type { SelectChangeEvent } from '../formControls/Select'
import ShareLoanAssignedRoleCell from './ShareLoanAssignedRoleCell'

type ShareLoanListProps = {
	userId: string
	loading?: boolean
	isSubmitting?: boolean
	showRolesBasedOnUserRole?: boolean
	selectedUserRoles: UserRole[]
	onChangeRoleItem?: (
		e: SelectChangeEvent<unknown>,
		userId: string
	) => void
	onRevokeUser: (userId: string) => void
}

const ShareLoanList = ({
	loading,
	userId,
	onRevokeUser,
	isSubmitting,
	onChangeRoleItem,
	selectedUserRoles,
	showRolesBasedOnUserRole,
}: ShareLoanListProps) => {
	const { formatMessage } = useIntl()

	const isUserRoleSelected = !!selectedUserRoles[0]

	const columns: TableColumn<UserRole>[] = [
		{
			name: formatMessage({
				id: 'share_loan.name',
			}),
			selector: (row) => row.user.name,
			cell: (row) => <ShareLoanListNameCell row={row} />,
			sortable: true,
		},
		{
			name: formatMessage({
				id: 'share_loan.assigned_role',
			}),
			selector: (row) => row.assignedRole,
			cell: (row) => (
				<ShareLoanAssignedRoleCell
					row={row}
					userId={userId}
					isSubmitting={isSubmitting}
					showRolesBasedOnUserRole={showRolesBasedOnUserRole}
					onChangeRoleItem={onChangeRoleItem}
				/>
			),
			sortable: true,
		},
		{
			name: '',
			cell: (row) => (
				<ShareLoanActionsCell
					row={row}
					userId={userId}
					isSubmitting={isSubmitting}
					onRevokeUser={onRevokeUser}
				/>
			),
			ignoreRowClick: true,
			allowOverflow: true,
			button: true,
		},
	]

	if (!isUserRoleSelected) return <ShareLoanEmptyState />

	return (
		<DataTable
			keyField="id"
			data={selectedUserRoles}
			progressPending={loading}
			columns={columns}
			pagination={false}
		/>
	)
}

export default ShareLoanList
